import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

import { Heading } from 'Components/_theme'

export const OrderConfirmationHeadingRow = (props: {
  shouldShowRequestIdColumn: boolean
}) => {
  const { shouldShowRequestIdColumn } = props

  return (
    <Row className="order-container grey-container p-4 d-flex justify-content-right justify-content-md-between align-items-center">
      <Col className="ps-0" md={6} xs={12}>
        <Heading as={6} size={3}>
          <FormattedMessage id="NewOrderConfirmation_items" />
        </Heading>
      </Col>

      {shouldShowRequestIdColumn && (
        <Col className="d-none d-md-flex justify-content-md-end" md={2} xs={0}>
          <Heading as={6} size={3}>
            <FormattedMessage id="NewOrderConfirmation_request_id" />
          </Heading>
        </Col>
      )}

      <Col className="d-none d-md-flex justify-content-md-end" md={2} xs={0}>
        <Heading as={6} size={3}>
          <FormattedMessage id="NewOrderConfirmation_rental_period" />
        </Heading>
      </Col>

      <Col
        className="d-none d-md-flex justify-content-md-end pe-0"
        md={2}
        xs={0}
      >
        <Heading as={6} size={3}>
          <FormattedMessage id="NewOrderConfirmation_price" />
        </Heading>
      </Col>
    </Row>
  )
}
